export default {
  namespaced: true,

  state () {
    return {
      campaign: null,
    }
  },
  mutations: {
    updateCampaign (state, payload) {
      state.campaign = payload
      console.log("state.campaign=", state.campaign)
    },
  },
  actions: {
    updateCampaign (context, payload) {
      console.log("payload=", payload)
      context.commit("updateCampaign", payload)
    },
  },
  getters: {
    getCampaign (state) {
      return {
        campaign: state.campaign,
      }
    },
  },
}
